import React, { useState } from 'react';
import './NotificariCard.css';
import { requestNotificationPermission } from '../notifications';

const NotificariCard = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleNotifications = async () => {
    setLoading(true);
    setMessage('');

    try {
      const token = await requestNotificationPermission();

      if (token) {
        console.log('Token primit:', token);
        setMessage('Notificarile au fost activate!');
      } else {
        setMessage('Notificarile nu au putut fi activate.');
      }
    } catch (error) {
      console.error('Eroare la activarea notificarilor:', error);
      setMessage('A aparut o eroare la activarea notificarilor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="notificari-card">
      <h2>Notificari</h2>

      <p>
        Activeaza notificarile pentru a primi remindere despre lectii,
        misiuni si progresul tau.
      </p>

      <button
        onClick={handleNotifications}
        disabled={loading}
      >
        {loading ? 'Se activeaza...' : 'Activeaza notificarile'}
      </button>

      {message && (
        <p className="notificari-message">
          {message}
        </p>
      )}
    </div>
  );
};

export default NotificariCard;